import { render, staticRenderFns } from "./MenuBtn.vue?vue&type=template&id=4b3ab2e6&scoped=true"
import script from "./MenuBtn.vue?vue&type=script&lang=js"
export * from "./MenuBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3ab2e6",
  null
  
)

export default component.exports